export const renderHighlightedText = (formattableText) => {
    const { text, matches } = formattableText;

    if (!matches || matches.length === 0) {
        return text;
    }

    const parts = [];
    let lastIndex = 0;

    matches.forEach((match, i) => {
        const { startOffset, endOffset } = match;

        if (startOffset > lastIndex) {
            parts.push(text.slice(lastIndex, startOffset));
        }

        parts.push(
            <strong key={i}>{text.slice(startOffset, endOffset)}</strong>,
        );

        lastIndex = endOffset;
    });

    if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex));
    }

    return parts;
};
